<template>
    <spinner-until :condition="!showSpinner">
        <div class="patient-details mt-page">

            <b-row class="mb-3 align-items-md-center">
                <b-col cols="12" md="3">
                    <h1 class="mb-md-0">
                        {{ $i18n.gt('HEADING_MANAGE_RECORDS') }}
                    </h1>
                </b-col>
                <b-col cols="12" md="7" class="text-center">
                    <patient-id :participant="participant" class="mb-3 mb-md-0">
                    </patient-id>
                </b-col>
                <b-col cols="12" md="2" class="text-right">
                    <div class="next-page">
                        <router-link :to="`/participant/chart/id/${participantId}`">
                            <shs-icon name="chevron-right"></shs-icon>
                            <span class="next-page__text">{{ $i18n.gt('LABEL_AT_A_GLANCE') }}</span>
                        </router-link>
                    </div>
                </b-col>
            </b-row>

            <patient-details-summary :participantId="participant.id">
            </patient-details-summary>

            <biometrics-list></biometrics-list>

            <anthropometrics-list></anthropometrics-list>

            <b-card no-body>
                <b-card-header>
                    <h5>{{ $i18n.gt('HEADING_QUESTIONNAIRES') }}</h5>
                </b-card-header>
                <b-card-body>
                    <patient-surveys :participantId="participantId">
                    </patient-surveys>
                </b-card-body>
            </b-card>

        </div>
    </spinner-until>
</template>

<!-- ----------------------------------------------------------------------- -->

<script>
import PractitionerPatientMixin from "@/providers/PractitionerPatientMixin";
import AnthropometricsList from "@/components/AnthropometricsList";

/**
 * Page for Practitioner to view Participant's basic info, Biometrics and Surveys
 */
export default {
    name: 'PatientDetails',
    components: {AnthropometricsList},
    mixins: [PractitionerPatientMixin],
    props: {
        participantId: Number
    },
    computed: {
        showSpinner() {
            // don't show until participant loaded, or if previous patient is still loaded
            return !this.participant || !this.participant.id || this.participant.id != this.participantId
        }
    },
    mounted() {
        // always reload participant data here - to cover cases such as
        // exiting a survey via the breadcrumbs
        this.loadParticipant(true) // see PractitionerPatientMixin
    }
}
</script>
